
import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";

import icon from "../../../assets/static/images/secciones/bandejaentrada.png";

import Inicio from "./Inicio";
import Convenios from "../Convenios/Convenios";
import PlanesDePago from "../PlanesDePago/PlanesDePago";
import { AbogadoModal } from "../../../components/AbogadoModal";
import { useUser } from "../../../hooks/useUser";
import ArrowBack from "../../../components/ArrowBack";
import { useSelector } from "react-redux";

const MesaEntradasExtrajudicial = () => {
  const { abogadoExtrajudicial } = useSelector((e) => e.mesasEntrada);

  const [key, setKey] = useState("inicio");
  const [show, setShow] = useState(false);
  const [abogado, setAbogado] = useState("");
  const [dataList, setDataList] = useState([]);
  const [tab, setTab] = useState("ACTIVOS");
  const user = useUser();

  useEffect(() => {
    if (abogadoExtrajudicial) {
      setAbogado(abogadoExtrajudicial);
    }
    else if (user.abogado === "A00" && !abogado) {
      setShow(true);
    } else {
      setAbogado(user.abogado);
    }
  }, []);

  const handleKey = (e) => {
    setKey(e);
  };

  const handleClose = () => setShow(false);

  return (
    <div className="section-content inbox-section mesa-judicial">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="bandejaentrada" />
        <span>Mesa de entradas extrajudicial</span>
      </div>
      <ArrowBack />

      {abogado && !show && (
        <Tabs
          activeKey={key}
          onSelect={handleKey}
          className="w-full mt-5"
        >
          <Tab eventKey="inicio" title="Inicio">
            {key === "inicio" && <Inicio abogado={abogado} dataList={dataList} setDataList={setDataList} tab={tab} setTab={setTab} />}
          </Tab>
          <Tab eventKey="convenios" title="Convenios">
            {key === "convenios" && <Convenios abogado={abogado} />}
          </Tab>
          <Tab eventKey="planesdepago" title="Planes de Pago">
            {key === "planesdepago" && <PlanesDePago abogado={abogado} />}
          </Tab>
        </Tabs>
      )}

      {show && <AbogadoModal show={show} handleClose={handleClose} setAbogado={setAbogado} abogado={abogado} extrajudicial />}
    </div>
  );
};


export default MesaEntradasExtrajudicial;